angular.module('tgaApp').controller('GameOverController', [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$window',
  'gameService',
  'scoreService',
  'gameConfig',
  'soundService',
  'scormService',
  'URLParamsService',
  '$uibModal',
  '$log',
  'userService',
  'messagingService',
  function (
    $scope,
    $rootScope,
    $state,
    $timeout,
    $window,
    gameService,
    scoreService,
    gameConfig,
    soundService,
    scormService,
    URLParamsService,
    $uibModal,
    $log,
    userService,
    messagingService,
  ) {
    $scope.initialize = function () {
      $log.debug('Game Over state');
      if (scormService.isConnected()) {
        $scope.isScorm = true;
      } else {
        $scope.isScorm = false;
      }
      // Tell iframe we've reached game over screen
      $window.parent.postMessage({ type: 'tga_game', action: 'game_over' }, '*');

      $scope.leaderboardEnable = $scope.game.show_leaderboard;
      $scope.percentCorrect = Math.floor(
        ($scope.gameData.questionsAnsweredCorrect / $scope.gameData.questionsAnswered) * 100,
      );
      if ($scope.gameData.data.scorm_pass_fail) {
        const passed = $scope.percentCorrect >= $scope.gameData.data.percent_required;
        scormService.setPassFail(passed);
      }
      $scope.splashLogoImg = $scope.game.splash.logo.image.url;
      // Report score
      $scope.playAgainDisabled = userService.checkSessionLimitReached();
      scoreService.reportScore(
        {
          game_id: $scope.game.game_id,
          points: $scope.gameData.currentScore,
          time: Date.now() - $scope.gameData.sessionStartTime - $scope.gameData.totalPausedTime,
          complete: true,
        },
        (response) => {
          $scope.leaderboardName = $rootScope.display_name;
          $scope.leaderboardScore = $scope.gameData.currentScore;
          $scope.leaderboardRank = response.data.rank;
          $scope.player = userService.getUserData();
          $window.parent.postMessage({ type: 'tta', key: 'score', value: response.data.points }, '*');
          $window.parent.postMessage(
            {
              type: 'tta',
              key: 'percent_correct',
              value: $scope.percentCorrect,
            },
            '*',
          );

          // Get leaderboad
          scoreService.getLeaderboard(
            {
              game_id: $scope.game.game_id,
              best: 'highest',
              limit: 10,
            },
            (r) => {
              $scope.leaderboardData = r.data;
            },
          );
        },
      );
    };

    $scope.URLParams = URLParamsService.getUserParams();

    $scope.showLeaderboard = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }
      $scope.show_leaderboard = true;
    };

    $scope.leaderboardExit = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }
      $scope.show_leaderboard = false;
    };

    $scope.learnMore = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }
      $window.open($scope.game.learn_more_url);
    };

    $scope.playAgain = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }
      $scope.reset();
      $scope.setState('game');
    };

    $scope.mainMenu = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }
      $scope.reset();
      $rootScope.display_name = null;
      $scope.setState('splash');
    };

    $scope.closeGame = function () {
      messagingService.finish();
      scormService.finish();
    };

    $scope.logout = function () {
      const redirect = $scope.gameData.data.sso_redirect_url;
      $window.location.href = `${redirect}&logout=true`;
    };

    $scope.showAnswerHistory = function () {
      if (!gameConfig.sfx_muted) {
        soundService.play('click');
      }

      // pause the question timer...

      $scope.menuOpen = true;

      $uibModal
        .open({
          animation: true,
          appendTo: angular.element('.gameContainer'),
          templateUrl: 'partials/modal_history.html',
          controller: 'MenuController',
          scope: $scope,
          backdrop: 'static',
          windowClass: 'menu-modal',
          keyboard: false,
          resolve: {
            data() {
              return {
                title: 'ANSWER HISTORY',
                history: $scope.gameData.answerHistory,
              };
            },
          },
        })
        .result.then(() => {
          $scope.menuOpen = false;
        })
        .catch(angular.noop);
    };

    $scope.initialize();
  },
]);
